import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { TableEnums } from "models/enums";
import { ReportConstants } from "utils/constants";
//#endregion
//#region components
import { PageLayouts, ReloadEvent, TableContextProvider } from "components/common";
import { Grid } from "@mui/material";
import QualifiedShareDividendList from "./list";
import { useQualifiedShareDividendsService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const QualifiedShareDividendReport: React.FC = () => {
  const qualifiedShareDividendsService = useQualifiedShareDividendsService();
  return (
    <ReloadEvent
      uniqueKey={ReportConstants.ReportKeys.QualifiedShareDividend}
      render={(reloadKey, reload) => (
        <PageLayouts.DashboardLayout
          entityKey={`qualified-share-dividend`}
          hasPermissions={qualifiedShareDividendsService.hasQualifiedShareDividendReportPermissions()}
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.K10Forms)}
        >
          <Grid container item>
            <TableContextProvider tableKey={TableEnums.TableType.QualifiedShareDividendList}>
              <QualifiedShareDividendList reloadKey={reloadKey} reloadQualifiedShareDividends={reload} />
            </TableContextProvider>
          </Grid>
        </PageLayouts.DashboardLayout>
      )}
    />
  );
};

export default QualifiedShareDividendReport;
